'use client';

import { notFound } from 'next/navigation';

import { useFeatureToggle } from 'hooks/use-feature-toggle';

export const FeatureToggleChecker = ({
  features,
  strategy,
  children,
}: {
  features: string[];
  strategy: 'all' | 'one';
  children: React.ReactNode;
}) => {
  const { isEnabled } = useFeatureToggle();
  const isFeatureCompliant =
    strategy === 'all'
      ? features.every((feature) => isEnabled(feature))
      : features.some((feature) => isEnabled(feature));

  if (!isFeatureCompliant) return notFound();
  return <>{children}</>;
};
